(function(){
  var root=(window.Shopify&&Shopify.routes&&Shopify.routes.root)||'/';
  function wrap(){return document.getElementById('shopify-section-vr-cart')}
  function drawer(){return document.querySelector('[data-vr-cart]')}
  function open(){var d=drawer();if(!d){location.href=root+'cart';return}d.hidden=false;document.documentElement.style.overflow='hidden'}
  function close(){var d=drawer();if(d)d.hidden=true;document.documentElement.style.overflow=''}
  function setCount(n){document.querySelectorAll('[data-vr-count]').forEach(function(e){e.textContent=n;e.hidden=!n})}
  function refresh(keepOpen){
    return fetch(root+'?sections=vr-cart').then(function(r){return r.json()}).then(function(j){
      var w=wrap();if(!w||!j['vr-cart'])return;var t=document.createElement('div');t.innerHTML=j['vr-cart'];
      var nw=t.querySelector('#shopify-section-vr-cart')||t.firstElementChild;w.innerHTML=nw.innerHTML;
      if(keepOpen)open();
      return fetch(root+'cart.js').then(function(r){return r.json()}).then(function(c){setCount(c.item_count)});
    });
  }
  window.vrCart={open:open,close:close,refresh:refresh};
  document.addEventListener('click',function(e){
    var o=e.target.closest('[data-vr-cart-open]');if(o){e.preventDefault();open();return}
    if(e.target.closest('[data-vr-cart-close]')){e.preventDefault();close();return}
    var q=e.target.closest('[data-vr-qty]');
    if(q){e.preventDefault();var d=drawer();if(d)d.classList.add('is-busy');
      fetch(root+'cart/change.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({line:+q.dataset.vrQty,quantity:+q.dataset.q})})
      .then(function(){return refresh(true)});}
  });
  document.addEventListener('keydown',function(e){if(e.key==='Escape')close()});
  document.addEventListener('submit',function(e){
    var f=e.target.closest('form[data-vr-atc]');if(!f)return;e.preventDefault();
    var btn=f.querySelector('[type=submit]'),err=f.querySelector('[data-vr-err]');if(btn)btn.disabled=true;if(err)err.hidden=true;
    fetch(root+'cart/add.js',{method:'POST',headers:{'Accept':'application/json'},body:new FormData(f)})
    .then(function(r){return r.json().then(function(j){if(!r.ok)throw j;return j})})
    .then(function(){return refresh(true)})
    .catch(function(x){if(err){err.textContent=(x&&x.description)||'Er ging iets mis.';err.hidden=false}})
    .finally(function(){if(btn)btn.disabled=false});
  });
})();
